<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="p-2">
      <b-col cols="11">
        <b-form inline>
          <b-form-select
            style="min-width:200px;"
            class="m-1"
            :options="orgList"
            v-model="queryParam.criteria.orgId"
            v-if="showOrg"
            placeholder="请选择机构"
          ></b-form-select>
          <b-form-select
            style="min-width:120px;"
            class="m-1"
            :options="invTypeList"
            v-model="queryParam.criteria.invTypeCode"
          ></b-form-select>
          <b-form-select
            style="min-width:130px;"
            class="m-1"
            :options="entList"
            v-model="queryParam.criteria.buyerTaxCode"
          ></b-form-select>

          <b-form-input
            style="min-width:320px;"
            class="m-1"
            placeholder="开票方/报销人/发票号码/凭证号/报销单号"
            v-model="queryParam.criteria.keyword"
          ></b-form-input>

          <date-range-picker
            ref="picker"
            opens="center"
            :locale-data="{ locale: daterange.local, format: 'yyyy-MM-dd' ,applyLabel:'确定',cancelLabel:'取消'}"
            :ranges="daterange.ranges"
            v-model="queryParam.criteria.daterange"
            style="min-width:200px;"
            placeholder="入账日期"
            class="m-1"
          ></date-range-picker>

          <b-button variant="outline-primary" @click="list(1)" class="m-1">查询</b-button>
          <!-- <json-excel :fields="excel.fields" :fetch="exportData" :name="excel.name" type="xls">
            <b-button variant="primary" class="ml-3">导出</b-button>
          </json-excel>-->
        </b-form>
      </b-col>
      <b-col cols="1">
        <b-dropdown class="m-1 float-right" left text="导出" variant="primary">
          <b-dropdown-item @click="handleExportDoc('1')">电子档案</b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(status)="data">
          <b-badge variant="warning" class="mr-2">{{getInvTypeName(data.item.cataCode)}}</b-badge>
          <b-badge variant="info" v-if="data.item.fileFormat=='PDF'" class="mr-2">PDF</b-badge>
          <b-badge variant="success" v-if="data.item.fileFormat=='OFD'" class="mr-2">OFD</b-badge>
          <b-badge variant="secondary" v-if="data.item.fileFormat==null" class="mr-2">无</b-badge>
          <b-badge
            variant="warning"
            v-if="data.item.fileFormat!='OFD' && data.item.fileFormat!='PDF' && data.item.fileFormat!=null"
            class="mr-2"
          >图片</b-badge>
        </template>

        <template v-slot:cell(invCode)="data">
          <b-link @click="handleView(data.item.id)">{{data.item.invCode+'-'+data.item.invNo}}</b-link>
        </template>

      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>

  </div>
</template>

<script>
import * as archieveFacade from "../../../api/archive-facade.js";
import * as orgFacade from "../../../api/org-facade.js";
import * as entFacade from "../../../api/ent-facade.js";
import { mapState } from "vuex";
import { zhCN } from "date-fns/locale";
import {
  addDays,
  addHours,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";

//import dayjs from "dayjs";

export default {
  // validations:
  data() {
    return {
      orgList: [
        { text: "机构", value: "" },
        { text: "机构一", value: "1" }
      ],
      accStatusList: [
        { text: "入账状态", value: "" },
        { text: "未入账", value: "0" },
        { text: "已入账", value: "1" }
      ],
      invTypeList: [
      { text: "票种", value: "" },
        { text: "增值税电子普通发票", value: "10" },
        { text: "增值税电子专用发票", value: "20" },
        { text: "电子发票（增值税专用发票）", value: "31" },
        { text: "电子发票（普通发票）", value: "32" },
        { text: "电子发票（铁路电子客票）", value: "51" },
        { text: "电子发票（航空运输客票电子行程单）", value: "61" },
        { text: "纸质发票（增值税专用发票）", value: "85" },
        { text: "纸质发票（普通发票）", value: "86" },
        { text: "增值税专用发票", value: "01" },
        { text: "增值税普通发票", value: "04" }
      ],
      entList: [
        { text: "受票方", value: "" },
        { text: "客户一", value: "444444444" },
        { text: "客户二", value: "555555555" }
      ],
      accEntList: [],
      localAccTime: new Date(),
      daterange: {
        local: zhCN,
        locale: {
          localize: "zhCN",
          //汉化
          format: "YYYY-MM-DD", //设置显示格式
          applyLabel: "确定", //确定按钮文本
          cancelLabel: "取消", //取消按钮文本
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          firstDay: 1
        },
        dateFormat: "yyyy-MM-dd",
        ranges: {
          今天: [new Date(), new Date()],
          昨天: [addDays(new Date(), -1), addDays(new Date(), -1)],
          本月: [startOfMonth(new Date()), endOfMonth(new Date())],
          本年: [startOfYear(new Date()), endOfYear(new Date())],
          上一周: [
            addDays(startOfWeek(addWeeks(new Date(), -1)), 1),
            addDays(endOfWeek(addWeeks(new Date(), -1)), 1)
          ],
          上一月: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1))
          ]
        }
      },

      fields: [
        {
          key: "status",
          label: "状态",
        },

        {
          key: "orgName",
          label: "机构"
        },
        {
          key: "invCode",
          label: "发票代码-号码"
        },
        {
          key: "sellerName",
          label: "开票方"
        },
        {
          key: "buyerName",
          label: "受票方"
        },
        {
          key: "issueDate",
          label: "开票日期"
        },
        {
          key: "noTaxAmount",
          label: "不含税金额"
        },
        {
          key: "accTime",
          label: "入账时间"
        },
        {
          key: "voucherId",
          label: "凭证号"
        },
        {
          key: "expenseReportId",
          label: "报销单号"
        },
        {
          key: "expenseEmpName",
          label: "报销人"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: "",
          accStatus: "",
          invTypeCode: "",
          buyerTaxCode: "",
          keyword: "",
          daterange: {
            startDate: addDays(new Date(), -90),
            endDate: new Date()
          },
          uploadDate: []
        },
        sortOrder: { accTime: "descending" }
      },
      //入账条件
      accountParam: {
        invoiceId: "",
        entCode: "",
        accTime: null
      },
      exportParam: {
        deviceNo: "",
        collectDate: []
      },

      excel: { data: [], fields: {}, name: "" },

      // 以上为数据展示和传输对象

      // 以下为页面状态控制参数
      showOrg: false,
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      accountDialogVisible: false

      // 以下为表单校验规则

      // 以上为表单校验规则
    };
  },
  watch: {
    "queryParam.criteria.orgId"() {
      if (this.queryParam.criteria.orgId) {
        entFacade
          .findByOrgId(this.queryParam.criteria.orgId)
          .then(res => {
            this.parseEntInfo(res);
          })
          .catch(err => {
            console.log("err", err);
            this.pageLoading = false;
          });
      }
    }
  },
  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    this.initInfo();
  },
  mounted() {
    // 异步加载列表数据

    this.handleQuery();
    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {
    // 异步加载列表数据
    list(page) {
      if (this.queryParam.criteria.daterange) {
        this.queryParam.criteria.uploadDate[0] = addHours(
          this.queryParam.criteria.daterange.startDate,
          8
        );
        this.queryParam.criteria.uploadDate[1] = addHours(
          this.queryParam.criteria.daterange.endDate,
          8
        );
      }
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      archieveFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    //查看发票
    handleView(id) {
      // this.$router.replace({
      //   name: "view",
      //   params: { invoiceId: id }
      // });
      const { href } = this.$router.resolve({
        name: "view",
        query: { c: id }
      });

      window.open(href, "_blank");
    },

    // 执行查询操作
    handleQuery() {
      this.list();
    },


    // 执行档案导出
    handleExportDoc(val) {
      this.queryParam.archive = val;
      console.log(this.queryParam.criteria);
      if (this.queryParam.criteria.daterange) {
        this.queryParam.criteria.uploadDate[0] = addHours(
          this.queryParam.criteria.daterange.startDate,
          8
        );
        this.queryParam.criteria.uploadDate[1] = addHours(
          this.queryParam.criteria.daterange.endDate,
          8
        );
      }
      archieveFacade
        .eidownloads(this.queryParam.criteria) // 异步调用后台接口
        .then(response => {
          console.log(response);
          // var blob = new Blob([response.data])
          // console.log(blob)
          // if (response.headers['content-type'] === 'APPLICATION/OCTET-STREAM') {
          let filename = "发票.zip";
          //response.data为下载的文件数据
          let url = window.URL.createObjectURL(new Blob([response]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          // }
        });
    },

    //获取机构信息
    async getOrgInfo() {
      this.pageLoading = true;
      orgFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let orgList = [{ text: "机构", value: "" }];

          res.map(item => {
            let org = {};
            org.text = item.name;
            org.value = item.id;
            orgList.push(org);
          });
          this.orgList = orgList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //获取企业信息
    async getEntInfo() {
      this.pageLoading = true;
      entFacade
        .findByUser()
        .then(res => {
          this.parseEntInfo(res);
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //初始化信息
    initInfo() {
      let roles = this.info.roles;
      //系统管理员
      if (roles.indexOf("sys_admin") > -1) {
        this.showOrg = true;
        this.getOrgInfo();
        this.getEntInfo();
      } else {
        //机构管理员或者财务经理
        this.showOrg = false;
        this.getEntInfo();
        // 表格中不显示机构信息
        this.fields.splice(1, 1);
      }
    },
    //解析企业信息
    parseEntInfo(res) {
      this.pageLoading = false;
      let entList = [{ text: "受票方", value: "" }];
      let accEntList = [];
      if (res) {
        res.map(item => {
          let ent = {};
          ent.text = item.entName;
          ent.value = item.entCode;
          entList.push(ent);
          accEntList.push(ent);
        });
      }

      this.entList = entList;
      this.accEntList = accEntList;
      if (this.accEntList.length > 0) {
        this.accountParam.entCode = this.accEntList[0].value;
      }
    },
    // 获取票种的简称
    getInvTypeName(code) {
      switch (code) {
        case "01":
          return "纸专";
        case "04":
          return "纸普";
        case "10":
          return "电普";
        case "20":
          return "电专";
        case "31":
          return "全电专";
        case "32":
          return "全电普";
        default:
          return "未知";
      }
    }
  }
};
</script>

<style >
.time-collected-width {
  min-width: 120px;
}
.actions {
  width: 150px;
}
.blank {
  width: 150px;
}
.vs__dropdown-toggle {
  height: 33.5px;
}
</style>
